module.exports = __webpack_public_path__ + "img/logo_header.31d83701.png";